export class ResetPasswordModel {
    constructor(       
        public email: string = null,
        public password: string = null,
        public confirmPassword: string = null,
        public code: string = null
    ) { }
}